export interface UserWorkHistoryModel {
  id: string;
  position_id: string | null;
  position_name: string | null;
  company_name: string | null;
  job_description: string | null;
  start_date: string | null;
  end_date: string | null;
  is_current: boolean;
  order: number;
}

export interface EditUserWorkHistoryListModel {
  items: UserWorkHistoryModel[] | null;
}
